import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Button, Divider, Input, Table} from "antd";
// import CertificateNavModule from "../../components/certificateNavModule";
import {showWarning} from "../../utils";

const CertSearch = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "证书查询",
        },
    ];

    const columns = [
        {
            title: '序号',
            dataIndex: 'order',
            key: 'order',
        },
        {
            title: '证书编号',
            dataIndex: 'certificateNumber',
            key: 'certificateNumber',
        },
        {title: '生产者(制造商)', dataIndex: 'manufacturer', key: 'manufacturer'},
        {title: '生产企业', dataIndex: 'productionEnterprise', key: 'productionEnterprise'},
        {title: '单元名称', dataIndex: 'unitName', key: 'unitName'},
        {title: '标准', dataIndex: 'standard', key: 'standard'},
        {title: '首次发证日期', dataIndex: 'firstIssueDate', key: 'firstIssueDate'},
        {title: '发证日期', dataIndex: 'issueDate', key: 'issueDate'},
        {title: '证书截止日期', dataIndex: 'expiryDate', key: 'expiryDate'},
        {title: '现状态', dataIndex: 'status', key: 'status'},

    ]

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                {/*<div className={style.leftNavBar}>*/}
                {/*    <CertificateNavModule/>*/}
                {/*</div>*/}

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>证书查询</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>CERTIFICATE SEARCH</Divider>
                    </div>


                    <div className={style.searchResultContainer}>
                        <div className={style.searchWrapper}>
                            <div className={style.searchItem}>
                                <div className={style.searchItemTitle}>证书编号:</div>
                                <Input className={style.searchItemInput} placeholder={'精准查询'}/>
                            </div>

                            <div className={style.searchItem}>
                                <div className={style.searchItemTitle}>制造商:</div>
                                <Input className={style.searchItemInput} placeholder={'模糊查询'}/>
                            </div>

                            <div className={style.searchItem}>
                                <div className={style.searchItemTitle}>生产企业:</div>
                                <Input className={style.searchItemInput} placeholder={'模糊查询'}/>
                            </div>
                            <Button type={'primary'} onClick={() => {
                                showWarning("未查询到证书信息!");
                            }}>查询</Button>

                        </div>
                        <Table style={{height: '500px', width: "90%", margin: "0 auto", marginTop: "20px"}}
                               columns={columns} dataSource={[]}/>

                    </div>

                </div>
            </div>

        </div>

    );
};

export default CertSearch;